import { z } from 'zod';

import {
  CallStatusSchema,
  CallTypeSchema,
  EventTypeSchema,
  SourceTypeSchema,
} from '@/models/Call.ts';

export const OutsideNumberInfoSchema = z.object({
  id: z.string().nullable(),
  name: z.string().nullable(),
  type: z.string(),
});
export type OutsideNumberInfo = z.infer<typeof OutsideNumberInfoSchema>;

const RejectReasonSchema = z.object({
  id: z.string(),
});

export const CallLogSchema = z.object({
  callType: CallTypeSchema,
  eventType: EventTypeSchema,
  sourceType: SourceTypeSchema,
  outsideNumber: z.string().nullable(),
  platformNumber: z.string().nullable(),
  organizationId: z.string(),
  authorityId: z.string().nullable(),
  schemeId: z.string().nullable(),
  personId: z.string().nullable(),
  controllerId: z.string().nullable(),
  operatorId: z.string().nullish(),
  reasonOptionId: z.string().nullable(),
  outcomeOptionId: z.string().nullable(),
  associatedId: z.string().nullable(),
  associatedType: z.string().nullable(),
  status: CallStatusSchema,
  note: z.object({ content: z.string().optional() }).nullable().optional(),
  audioPath: z.string().nullable(),
  audioName: z.string().nullable(),
  audioDuration: z.number().nullable(),
  id: z.string(),
  callSessionId: z.string(),
  rejectReason: RejectReasonSchema.nullable().optional(),
  receiveTime: z.string(),
  deliverTime: z.string().nullable().optional(),
  answerTime: z.string().nullable(),
  endTime: z.string().nullable(),
  deviceAlarmId: z.string().nullable(),
  overflowOrganizationId: z.string().nullable(),
  createDate: z.string(),
  lastUpdateDate: z.string(),
  operatorName: z.string().nullish(),
  associatedName: z.string().nullish(),
  relationship: z.string().nullish(),
  outsideNumberInfo: OutsideNumberInfoSchema,
});
export type CallLog = z.infer<typeof CallLogSchema>;
